import { BlockVideoChange } from '@visikon/core-models/content';
import styled from 'styled-components';
import { ClipboardLinkButton } from '../../../../components/ClipboardLinkButton';
import { useWorkFileFromVideoSource } from 'api/v2/encoderApi';

const H3 = styled.h3`
  padding: 0;
  margin-bottom: 0;
`;

interface IProps {
  video: BlockVideoChange;
}
export const WorkFileList = ({ video }: IProps) => {
  const result = useWorkFileFromVideoSource(video.existingSource);

  if (!video?.existingSource) {
    return (
      <>
        <OriginalFileNameHeader fileName={video?.fileNameForShow} />
        <H3>Work files</H3>
        <div>Error: missing video source</div>
      </>
    );
  }

  if (result.isLoading || result.isIdle) {
    return (
      <>
        <OriginalFileNameHeader fileName={video?.fileNameForShow} />
        <H3>Work files</H3>
        <div>Loading...</div>
      </>
    );
  }

  if (result.isError) {
    return (
      <>
        <OriginalFileNameHeader fileName={video?.fileNameForShow} />
        <H3>Work files</H3>
        <div style={{ color: 'red' }}>Error: {result.error.message}</div>
      </>
    );
  }

  return (
    <>
      <OriginalFileNameHeader fileName={video?.fileNameForShow} />
      <H3>Work files</H3>
      <ul style={{ marginTop: 0 }}>
        {result.data.map((f) => (
          <li key={f}>
            <ClipboardLinkButton cleanup>{f}</ClipboardLinkButton>
          </li>
        ))}
      </ul>
    </>
  );
};

function OriginalFileNameHeader(props: { fileName: string | undefined }) {
  if (!props.fileName) {
    return null;
  }

  return (
    <>
      <h3 style={{ marginBottom: 0, padding: 0 }}>Original filename</h3>
      <div>
        <ClipboardLinkButton cleanup>{props.fileName}</ClipboardLinkButton>
      </div>
    </>
  );
}
